import React from "react";
import { ControlLabel, FormControl, Radio, Button, Modal } from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import { browserHistory } from "react-router";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import immutable from "immutable";
import moment from "moment";

import SearchForm from "./tc-management/search-form2.jsx";
import CreateTCForm from "./tc-management/create-tc-form.jsx";

const VERIFY_TIMECARD_VIEW = "verify-timecard";
const CREATE_TIMECARD_VIEW = "create-timecard";

export default class TCManagement2 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            role: context.getRouteParam(this, "role"),
            search: null,
            createTc: null,
            view: VERIFY_TIMECARD_VIEW
        };

        this.onFieldChange = this.onFieldChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onTcItemChecked = this.onTcItemChecked.bind(this);
        this.onVerify = this.onVerify.bind(this);
        this.search = this.search.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
        this.handleChangeTab = this.handleChangeTab.bind(this);
        this.onCreateNewTimecard = this.onCreateNewTimecard.bind(this);
    }


    onFieldChange(patch, callback) {
        let map = immutable.fromJS(this.state);
        const clone = map.mergeDeep(patch).toJS();
        this.setState(clone, function () {
            if (callback) callback();
        });
    }

    onSortChange(sort, callback) {
        let clone = immutable.fromJS(this.state).toJS();

        if (clone.search.sortExpression.indexOf(sort) > -1) {
            if (clone.search.sortExpression.indexOf('DESC') > -1) {
                clone.search.sortExpression = sort;
            }
            else {
                clone.search.sortExpression = sort + ' DESC';
            }
        }
        else {
            clone.search.sortExpression = sort;
        }

        this.setState(clone, function () {
            if (callback) callback();
        });
    }

    onNavigate(page) {
        let self = this;
        self.state.search.page = page;
        self.state.search.timecardList.isAllSelected = false;
        this.search();
    }

    onSearch() {
        let self = this;
        let vm = self.state;
        vm.search.page = 0;
        this.search();
    }

    onTcItemChecked(tcId) {
        let map = immutable.fromJS(this.state);
        let clone = map.toJS();
        if (tcId === "all") {
            clone.search.timecardList.isAllSelected = !clone.search.timecardList.isAllSelected;
            for (let i = 0; i < clone.search.timecardList.timecards.length; i++) {
                let tc = clone.search.timecardList.timecards[i].timecardSummary;
                let totalHours = parseFloat(tc.totalHour) + (parseFloat(tc.totalMin) / 60);
                if (totalHours > 0 && tc.isEdited == false && (tc.statusDescription.toLowerCase() == "submitted" || tc.statusDescription.toLowerCase() == "unsubmitted")) {
                    tc.isChecked = clone.search.timecardList.isAllSelected;
                }
            }
        } else {
            for (let i = 0; i < clone.search.timecardList.timecards.length; i++) {
                let tc = clone.search.timecardList.timecards[i].timecardSummary;
                if (tc.timecardId == tcId) {
                    tc.isChecked = tc.isChecked || false;
                    tc.isChecked = !tc.isChecked;
                    if (tc.submittedDate != null) {
                        clone.search.timecardList.isAllSelected = false;
                    }
                    break;
                }
            }
        }
        this.setState(clone);
    }

    onCreateNewTimecard() {
        let self = this;
        let clone = { ...this.state };
        context.message({
            show: true,
            type: "loading",
            message: "Adding new timecard. Please wait..."
        });
        ajax.api().post("create-timecard", {
            employeeName: clone.createTc.employee,
            employeeId: clone.createTc.employeeId,
            offsysId: clone.createTc.offsysId,
            reason: clone.createTc.reason,
            weekEndingDate: clone.createTc.selectedWeekEnding,
            role: clone.role
        }).then(function (res) {
            let map = immutable.fromJS(self.state.createTc);
            clone.createTc = map.set('messageType', "success")
                .set('message', (<span>Timecard was created successfully for <b>{clone.createTc.employee}</b></span>))
                .set('employee', "")
                .set('reason', "")
                .set('selectedWeekEnding', "")
                .toJS();
            self.setState(clone); // don't use mergeDeep because "message" contains an array. if old value has 3 elements and new value has only 2, the excess 1 element is preserved
            context.message({ show: false });
        }).catch(function (err) {
            let map = immutable.fromJS(self.state.createTc);
            let data = err.response.data;
            let errors = null;
            let errorItems = [];
            if (data.ClassName === "ActionPortal.ValidationException") {
                for (let key in data.Data.summary.validationResults) {
                    console.log(data.Data.summary.validationResults[key]);
                    errorItems.push((
                        <li key={key}>{data.Data.summary.validationResults[key]}</li>
                    ));
                }
                errors = (<ul>
                    {errorItems}
                </ul>);
            } else {
                errors = data.exceptionMessage || data.message;
            }
            clone.createTc = map.set('messageType', "danger")
                .set('message', errors)
                .toJS();
            self.setState(clone); // don't use mergeDeep because "message" contains an array. if old value has 3 elements and new value has only 2, the excess 1 element is preserved
            context.message({ show: false });
        });
    }

    onVerify() {
        let clone = this.state;
        context.message(
            {
                show: true,
                type: "loading",
                message: "Processing. Please wait...",
            });
        let self = this;
        let submitted = clone.search.status == "saved" ? 0 : 1;
        let timecards = [];
        for (let i = 0; i < clone.search.timecardList.timecards.length; i++) {
            let tc = clone.search.timecardList.timecards[i].timecardSummary;
            // if (!(tc.isEdited || tc.isIncomplete) && tc.isChecked) {
            //     timecards.push(tc.timecardId);
            // }
            let totalHours = parseFloat(tc.totalHour) + (parseFloat(tc.totalMin) / 60);
            if (totalHours > 0 && tc.isEdited == false && (tc.statusDescription.toLowerCase() == "submitted" || tc.statusDescription.toLowerCase() == "unsubmitted") && tc.isChecked) {
                timecards.push(tc.timecardId);
            }
        }
        ajax.api().post("payroll-admin/prepare-timecard-verification2",
            {
                timecards: timecards,
                role: clone.role,
                submitted: submitted,
                performValidation: true,
                mainUrl: ""
            })
            .then(function (res) {
                let data = res.data;
                //window.location = context.url("..", "common","approvetimecard.aspx?token=" + data.token + "&url=" + data.url);
                browserHistory.push(context.routeUrl(`${clone.role}/tc-approval/${submitted}/2`));
            }).catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    componentDidMount() {
        let self = this;

        ajax.vm().get("tc-management2/" + this.state.role)
            .then(function (res) {
                if (res.data.search.companies.length == 0) {
                    let url = context.routeUrl("home?msg=Missing%20assigned%20company%20for%20Payroll%20Admin.%20Please%20contact%20Help%20desk");
                    browserHistory.push(url);
                }
                self.setState(res.data);
                self.search();
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    handleChangeTab(view) {
        this.setState({ view });
    }

    search() {
        let self = this;
        let vm = self.state;
        context.message({ show: true, type: "loading", message: "Searching. Please wait..." });

        var weekEndingDate = vm.search.weekEndingDate;

        if (vm.search.weekEndingDate instanceof Date) {
            weekEndingDate = (vm.search.weekEndingDate.getMonth() + 1) + '/' + vm.search.weekEndingDate.getDate() + '/' + vm.search.weekEndingDate.getFullYear();
        }

        ajax.legacy().get("get-timecard-list/" + vm.role + "/" + vm.search.status, {
            params: {
                assocName: vm.search.associateName,
                weekEndingDate: weekEndingDate,
                office: vm.search.office,
                company: vm.search.company,
                p: vm.search.page,
                pz: vm.search.pageSize,
                version: '2',
                sortExpression: vm.search.sortExpression
            }
        })
            .then(function (res) {
                self.state.search.timecardList.timecards = [];
                self.state.search.timecardList.isAllSelected = false;
                let map = immutable.fromJS(self.state);
                self.setState(map.mergeDeep({
                    search: {
                        timecardList: res.data,
                    }
                }).toJS());
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    render() {
        const view = this.state.view;

        let people = this.state.peopleList;
        let peopleList = [];
        if (people != null) {
            for(let i=0; i < people.length; i++){
                let p = people[i];
                peopleList.push((<option key={`people_${i}`} value={p.fullName} />));
            }
        }

        return (
            <div className="ap-form-container">
                <datalist id="peopleName">
                    {peopleList}
                </datalist>
                <div className="container">
                    <div className="row hidden-sm hidden-xs">
                        <div className="col-md-12">
                            <h2 className="text-center ap-title verify-timecard">Timecard Management</h2>
                            <br />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-12">
                            <div className="row">
                                <div className={`col-xs-5 col-md-2 ap-accrual-tab text-center ${view === VERIFY_TIMECARD_VIEW ? "selected" : ""}`}>
                                    <span><a onClick={() => this.handleChangeTab(VERIFY_TIMECARD_VIEW)}>Timecard Management</a></span>
                                </div>
                                <div className={`col-xs-5 col-md-2 ap-accrual-tab text-center ${view === CREATE_TIMECARD_VIEW ? "selected" : ""}`}>
                                    <span><a onClick={() => this.handleChangeTab(CREATE_TIMECARD_VIEW)}>Create Timecard</a></span>
                                </div>
                                <div className={`col-xs-7 col-md-8 ap-accrual-tab text-center`} dangerouslySetInnerHTML={{ __html: "&nbsp;" }} />
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.view === VERIFY_TIMECARD_VIEW ?
                        <SearchForm onSearch={this.onSearch} onFieldChange={this.onFieldChange} vm={this.state.search} role={this.state.role}
                            onNavigate={this.onNavigate} onTcItemChecked={this.onTcItemChecked} onVerify={this.onVerify} onSortChange={this.onSortChange}
                            peopleList={this.state.peopleList} /> :
                        <CreateTCForm hideTitle={true} vm={this.state.createTc} onFieldChange={this.onFieldChange} onNewTimecard={this.onCreateNewTimecard} />
                }
            </div>
        );
    }
}